import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  blend: {
    label: 'Blend Pharmacy',
    functions: {
      CreateOrder: {
        middlewareHandler: 'blend',
        version: 2,
        label: 'Create Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      HandleWebhook: {
        middlewareHandler: 'blend',
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const BlendConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type BlendFunctionConfiguration = MiddlewareConfigClass<
  typeof config.blend.functions
>;
